// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1reaH","right":"styles_right__RLElA"};